import store from "../../store";

/* export default {
  dia: {
    from: moment()
      .startOf("day")
      .valueOf(),
    to: moment()
      .endOf("day")
      .valueOf()
  },
  semana: {
    from: moment()
      .startOf("week")
      .valueOf(),
    to: moment()
      .endOf("week")
      .valueOf()
  }
}; */
export default function() {
  const moment = store.state.ganttChart.moment.clone();
  return {
    dia: {
      from: moment.startOf("day").valueOf(),
      to: moment.endOf("day").valueOf()
    },
    "3 dias": {
      from: moment.startOf("day").valueOf(),
      to: moment
        .startOf("day")
        .add(2, "days")
        .valueOf()
    },
    semana: {
      from: moment.startOf("week").valueOf(),
      to: moment.endOf("week").valueOf()
    }
  };
}
